import React from "react";
import styles from "./button.module.css";

type ButtonColor = "primary" | "accent" | "background" | "background-light";
type TextColor = "text-color" | "light";

type ButtonProps = {
  label: string;
  onClick: () => void;
  classes?: string;
  color?: ButtonColor;
  textColor?: TextColor;
  disabled?: boolean;
  translate?: (text: string) => string;
};

const Button: React.FC<ButtonProps> = ({
  label,
  onClick,
  classes = "",
  color = "primary",
  textColor = "text-color",
  disabled = false,
  translate = (t) => t,
}) => {
  const buttonClass = `${styles.buttonContainer} ${styles[color]} ${
    styles[`label-${textColor}`]
  } ${classes}`;

  return (
    <button
      type="button"
      className={buttonClass}
      onClick={onClick}
      disabled={disabled}
    >
      {translate(label)}
    </button>
  );
};

export default Button;
